import { ArmyDataBase } from "../lib/db/types";

export const stalkers: ArmyDataBase = {
  ruleset_version: "2.0.0",
  name: "Tartarous' Stalkers",
  description:
    "Tartarous' Stalkers are a brutal force born of volcanic wastelands, striking with flame and fury. Masters of attrition, they unleash scorching close range firepower and devastating melee assaults.",
  keywords: [{ id: "COURAGEOUS", count: 1 }],
  units: [
    {
      name: "Tartarous' Captain",
      description:
        "A fearsome commander clad in magma-etched armor, the captain can further bolster the morale of your — already courageous — army.",
      type: "HEAVY_INFANTRY",
      keywords: [{ id: "LEADER", count: 1 }],
      abilities: [],
      count: 1,
    },
    {
      name: "Ashwalkers",
      description:
        "Swift and deadly, the Ashwalkers are a devastating force at close range, using their flame rifles and incendiary grenades to leave enemy lines in disarray.",
      type: "LIGHT_INFANTRY",
      keywords: [{ id: "FLAME_WEAPONS", count: 1 }],
      abilities: [],
      count: 2,
    },
    {
      name: "Stiltstorm Skywardens",
      description:
        "Hulking warriors outfitted with powerful exoskeletal armour, the Skywardens form the backbone of your force.\n\nTough to shift once dug in, they are great at capturing and holding objectives.",
      type: "HEAVY_INFANTRY",
      keywords: [{ id: "ARMORED", count: 1 }],
      abilities: [],
      count: 2,
    },
    {
      name: "Tartarous' Guard",
      description:
        "The Guard move slowly but deliberately alongside Tartarous, providing additional firepower against those that would dare attack the behemoth.",
      type: "LIGHT_INFANTRY",
      keywords: [{ id: "SLOW", count: 1 }],
      abilities: [],
      count: 2,
    },
    {
      name: "Tartarous",
      description:
        "A towering molten colossus and the embodiment of volcanic fury, Tartarous wields a massive thermal glaive that can cleave through ranks of enemies.\n\nIts Coerce ability forces enemies to move against their will, luring them into deadly fire lanes or into the jaws of its allies, ensuring total battlefield domination.",
      type: "WAR_BEHEMOTH",
      keywords: [],
      abilities: [{ id: "COERCE" }],
      count: 1,
    },
  ],
};

export const wardens: ArmyDataBase = {
  ruleset_version: "2.0.0",
  name: "Aetherveil Wardens",
  description:
    "The Aetherveil Wardens strike from extreme range and vanish without a trace. Led by the enigmatic Aethermarshal, they combine repair drones, agile hover-tanks, and devastating artillery to overwhelm enemies with unmatched finesse and power.",
  keywords: [],
  units: [
    {
      name: "Aethermarshal",
      description:
        "A battlefield commander offering vast tactical possibilities.\n\nUse the Leader keyword to bolser your units' morale, or create new battlefield opportunities with the Haste and Turn the Tides abilities.",
      type: "HEAVY_INFANTRY",
      keywords: [{ id: "LEADER", count: 1 }],
      abilities: [{ id: "TURN_THE_TIDES" }, { id: "HASTE" }],
      count: 1,
    },
    {
      name: "Shardweaver Drones",
      description:
        "Small, fragile drones that are perfect for keeping your expensive, long-range units on the table, even as they come under fire.\n\nDon't be afraid to throw them into close combat if enemies get close -- the Explosive keyword can deal a good amount of extra damage!",
      type: "LIGHT_INFANTRY",
      keywords: [
        { id: "BAD_SHOT", count: 1 },
        { id: "MECHANIC", count: 1 },
        { id: "EXPLODING", count: 1 },
      ],
      abilities: [],
      count: 2,
    },
    {
      name: "Thundercoil Skimmers",
      description:
        "A lightweight hover-tank with a refractive energy shell and a precision particle cannon.\n\nThundercoil Skimmers are your main battleline units, fulfilling whatever mission-critical role you might need.",
      type: "LIGHT_ARMORED_VEHICLE",
      keywords: [{ id: "FAST", count: 1 }],
      abilities: [],
      count: 2,
    },
    {
      name: "Stormforge Bastion",
      description:
        "An imposing warmachine armed with an experimental stormforge cannon capable of firing chain lightning rounds that devastate clustered enemies at extreme range.\n\nStormfire Bastion is your main damage dealer. The Chain Lightning keyword combined with the unit's extra long range can really put some hurt on your enemies.",
      type: "HEAVY_ARMORED_VEHICLE",
      keywords: [
        { id: "ARTILLERY", count: 1 },
        { id: "LONG_RANGE_WEAPONS", count: 2 },
        { id: "CHAIN_LIGHTNING", count: 1 },
      ],
      abilities: [{ id: "SMITE" }],
      count: 1,
    },
  ],
};
